import React from "react";

import { useFormSubmissionContext } from "../FormEngine/context";
import Button from "@src/multiCustodian/components/MUI/Button/Button";

const SaveButton: React.FC = () => {
  const { submit } = useFormSubmissionContext();

  return (
    <Button
      variant="contained"
      buttonType="primary"
      text="Save"
      onClick={submit}
    />
  );
};

export default SaveButton;
